import { render, staticRenderFns } from "./qyClassMsg.vue?vue&type=template&id=362c73e3&scoped=true"
import script from "./qyClassMsg.vue?vue&type=script&lang=js"
export * from "./qyClassMsg.vue?vue&type=script&lang=js"
import style0 from "./qyClassMsg.vue?vue&type=style&index=0&id=362c73e3&prod&lang=scss"
import style1 from "./qyClassMsg.vue?vue&type=style&index=1&id=362c73e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c73e3",
  null
  
)

export default component.exports